<template>
  <b-modal
    id="customer-modal"
    ref="modal"
    :title="title"
    @hidden="onClose"
    @show="onShow"
    size="lg"
  >
    <ValidationObserver ref="customerForm" tag="form" @submit.prevent="onSubmit" id="customerForm">
      <div class="row">
        <div class="col-lg-6">
          <div class="section-title">Dane Profilu:</div>
          <b-form-group
            label-cols-lg="3"
            label="Firma:"
            label-for="companyname"
            label-align-lg="right"
          >
            <ValidationProvider
              name="companyname"
              rules="max:191"
              vid="companyname"
              v-slot="validationContext"
            >
              <b-form-input id="companyname" v-model="form.companyname" type="text"></b-form-input>
              <b-form-invalid-feedback :force-show="true">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </ValidationProvider>
          </b-form-group>
          <b-form-group
            label-cols-lg="3"
            label="Nip:"
            label-for="vat_number"
            label-align-lg="right"
          >
            <ValidationProvider name="vat_number" rules="max:191" v-slot="validationContext">
              <b-form-input id="vat_number" v-model="form.vat_number" type="text"></b-form-input>
              <b-form-invalid-feedback :force-show="true">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </ValidationProvider>
          </b-form-group>
          <b-form-group
            label-cols-lg="3"
            label="Imię:"
            label-for="firstname"
            label-align-lg="right"
          >
            <ValidationProvider name="firstname" rules="max:191" v-slot="validationContext">
              <b-form-input id="firstname" v-model="form.firstname" type="text"></b-form-input>
              <b-form-invalid-feedback :force-show="true">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </ValidationProvider>
          </b-form-group>
          <b-form-group
            label-cols-lg="3"
            label="Nazwisko:"
            label-for="lastname"
            label-align-lg="right"
          >
            <ValidationProvider
              name="lastname"
              rules="max:191"
              vid="lastname"
              v-slot="validationContext"
            >
              <b-form-input id="lastname" v-model="form.lastname" type="text"></b-form-input>
              <b-form-invalid-feedback :force-show="true">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </ValidationProvider>
          </b-form-group>
        </div>
        <div class="col-lg-6">
          <div class="section-title">Dane adresowe:</div>
          <b-form-group label-cols-lg="4" label="Adres:" label-for="address" label-align-lg="right">
            <ValidationProvider
              name="address"
              rules="max:191"
              vid="address"
              v-slot="validationContext"
            >
              <b-form-input id="address" v-model="form.address" type="text"></b-form-input>
              <b-form-invalid-feedback :force-show="true">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </ValidationProvider>
          </b-form-group>
          <b-form-group label-cols-lg="4" label="Miasto:" label-for="city" label-align-lg="right">
            <ValidationProvider name="city" rules="max:191" vid="city" v-slot="validationContext">
              <b-form-input id="city" v-model="form.city" type="text"></b-form-input>
              <b-form-invalid-feedback :force-show="true">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </ValidationProvider>
          </b-form-group>
          <b-form-group
            label-cols-lg="4"
            label="Kod pocztowy:"
            label-for="postcode"
            label-align-lg="right"
          >
            <ValidationProvider
              name="postcode"
              rules="max:12"
              vid="postcode"
              v-slot="validationContext"
            >
              <b-form-input id="postcode" v-model="form.postcode" type="text"></b-form-input>
              <b-form-invalid-feedback :force-show="true">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </ValidationProvider>
          </b-form-group>
        </div>
      </div>
      <hr />
      <b-form-group label-cols-lg="2" label="Email:" label-for="email" label-align-lg="right">
        <ValidationProvider
          name="email"
          rules="email|max:191"
          vid="email"
          v-slot="validationContext"
        >
          <b-form-input id="email" v-model="form.email" type="text"></b-form-input>
          <b-form-invalid-feedback :force-show="true">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
        </ValidationProvider>
      </b-form-group>
      <b-form-group
        label-cols-lg="2"
        label="Tel. kontaktowy:"
        label-for="phone"
        label-align-lg="right"
      >
        <ValidationProvider name="phone" rules="max:24" v-slot="validationContext">
          <b-form-input id="phone" v-model="form.phone" type="text"></b-form-input>
          <b-form-invalid-feedback :force-show="true">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
        </ValidationProvider>
      </b-form-group>
    </ValidationObserver>
    <template v-slot:modal-footer="{cancel}">
      <b-button size="md" variant="primary" type="submit" form="customerForm">Zapisz</b-button>
      <b-button size="md" variant="outline-danger" @click="cancel()">Anuluj</b-button>
    </template>
  </b-modal>
</template>

<script>
// import customerManager from "@/services/customerManager.service";
import CustomersService from "@/services/customers.service";

export default {
  name: "ModalCustomer",
  props: {
    customer: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      form: {
        firstname: "",
        lastname: "",
        companyname: "",
        vat_number: "",
        address: "",
        city: "",
        postcode: "",
        email: "",
        phone: ""
      }
    };
  },
  computed: {
    title() {
      return this.$_.isEmpty(this.customer) === false
        ? "Edytuj klienta: " + this.customer.email
        : "Dodaj nowego klienta";
    },
    isEdited() {
      return this.$_.isEmpty(this.customer) === false;
    }
  },
  methods: {
    getValidationState({ validated, valid = null }) {
      return validated ? valid : null;
    },
    onShow() {
      if (this.isEdited) {
        this.$_.each(this.form, (v, k) => {
          this.form[k] = this.customer[k];
        });
      }
    },
    onClose() {
      this.$_.each(this.form, (value, key) => {
        this.form[key] = "";
      });
      this.$emit("onClose");
    },
    onSubmit() {
      this.$refs.customerForm.validate().then(success => {
        if (!success) {
          return;
        }
        this.$Progress.start();
        if (this.isEdited) {
          //-- EDITED
          CustomersService.update(this.customer.id, this.form)
            .then(data => {
              this.$_.each(data, (v, k) => {
                this.customer[k] = v;
              });
              this.$nextTick(() => {
                this.$bvModal.hide("customer-modal");
              });
            })
            .catch(error => {
              this.$refs.customerForm.setErrors(error.response.data.fields);
            });
        } else {
          //-- CREATE NEW
          CustomersService.create(this.form)
            .then(data => {
              this.$emit("onSubmit", data);
              this.$nextTick(() => {
                this.$bvModal.hide("customer-modal");
              });
            })
            .catch(error => {
              this.$refs.customerForm.setErrors(error.response.data.fields);
            });
        }
      });
    }
  }
};
</script>